import React from 'react';

import { Box } from '@mui/material';

interface Props {
  label: string;
  bg: string;
  color?: string;
}

// MUI Chip text is rendered using CSS manipulation - incompatible with HTML2Canvas
export default function PrintableChip({ label, bg, color = 'white' }: Props) {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-block',
        px: 1,
        py: 0.25,
        borderRadius: '12px',
        fontSize: 12,
        fontWeight: 600,
        lineHeight: '18px',
        textTransform: 'uppercase',
        backgroundColor: bg,
        color,
        verticalAlign: 'middle',
        mr: 1,
        my: 0.25,
      }}
    >
      {label}
    </Box>
  );
}
